import { call, put, select, takeLatest } from 'redux-saga/effects';
import * as apis from '@/apis/reservenumber';
import * as actions from '@/actions';
import {
  RESERVE_GET_SERVICE_NUMBERS_REQUEST,
  ADD_RESERVE_SERVICE_NUMBERS_REQUEST,
  GET_UN_RESERVED_SERVICE_NUMBERS_REQUEST,
  REMOVE_RESERVE_SERVICE_NUMBERS_REQUEST,
  GET_NEW_LINE_RESERVED_NUMBERS_REQUEST
} from '@/actions/reservenumber/actionTypes';

export const getAuth = (state) => state.auth;

function* getReservedServiceNumber(brn) {
  try {
    const {
      userInfo: { email }
    } = yield select(getAuth);

    const reservedBy = email;
    const result = yield call(apis.getReserveNumbers, brn.brn, reservedBy);
    yield put(actions.getReserveServiceNumbers.success(result.data));
  } catch (error) {
    yield put(actions.getReserveServiceNumbers.failure(error));
  }
}

function* getNewLineReservedNumber(payload) {
  try {
    const {
      reqData: { brn, reservedBy, cardProfile, simType }
    } = payload;
    const result = yield call(apis.getNewLineReservedNumbers, { brn, reservedBy, cardProfile, simType });
    yield put(actions.getNewLineReservedNumbers.success(result.data));
  } catch (error) {
    yield put(actions.getNewLineReservedNumbers.failure(error));
  }
}

function* addReserveServiceNumber(reqData) {
  try {
    const auth = yield select(getAuth);
    const { currentAccount } = auth;
    const {
      userInfo: { email }
    } = yield select(getAuth);
    const payload = {
      svcNo: reqData.svcNo,
      reservedBy: email,
      brn: currentAccount.brn
    };
    const result = yield call(apis.addReserveNumbers, payload);
    yield put(actions.addReserveServiceNumbers.success(result.data));
    yield put(actions.getReserveServiceNumbers.request(payload.brn, payload.reservedBy));
    yield put(actions.getUnReserveServiceNumbers.request(1, 1000));
  } catch (error) {
    yield put(actions.addReserveServiceNumbers.failure(error));
  }
}

function* getUnReservedServiceNumber(page) {
  try {
    const {
      currentAccount: { brn }
    } = yield select(getAuth);
    const result = yield call(apis.getUnReserveNumbers, page.page, page.size, brn);
    yield put(actions.getUnReserveServiceNumbers.success(result.data));
  } catch (error) {
    yield put(actions.getUnReserveServiceNumbers.failure(error));
  }
}

function* deleteReserveServiceNumber(reqData) {
  try {
    const auth = yield select(getAuth);
    const { currentAccount } = auth;
    const {
      userInfo: { email }
    } = yield select(getAuth);
    const payload = {
      svcNo: reqData.svcNo,
      reservedBy: email,
      brn: currentAccount.brn
    };
    const result = yield call(apis.removeReserveNumbers, payload);
    yield put(actions.addReserveServiceNumbers.success(result.data));
    yield put(actions.getUnReserveServiceNumbers.request(1, 1000));
    yield put(actions.getReserveServiceNumbers.request(payload.brn, payload.reservedBy));
  } catch (error) {
    yield put(actions.addReserveServiceNumbers.failure(error));
  }
}

export default function* reserveNumberSagas() {
  yield takeLatest(RESERVE_GET_SERVICE_NUMBERS_REQUEST, getReservedServiceNumber);
  yield takeLatest(GET_NEW_LINE_RESERVED_NUMBERS_REQUEST, getNewLineReservedNumber);
  yield takeLatest(ADD_RESERVE_SERVICE_NUMBERS_REQUEST, addReserveServiceNumber);
  yield takeLatest(GET_UN_RESERVED_SERVICE_NUMBERS_REQUEST, getUnReservedServiceNumber);
  yield takeLatest(REMOVE_RESERVE_SERVICE_NUMBERS_REQUEST, deleteReserveServiceNumber);
}
